function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m288.134 512h-64.267c-8.284 0-15-6.716-15-15v-176.733c0-8.284 6.716-15 15-15h64.267c8.284 0 15 6.716 15 15v176.733c0 8.284-6.716 15-15 15z",
  fill: "#deb176"
}), /*#__PURE__*/React.createElement("path", {
  d: "m303.134 497v-176.733c0-8.284-6.716-15-15-15h-32.134v206.733h32.134c8.284 0 15-6.716 15-15z",
  fill: "#bc8f57"
}), /*#__PURE__*/React.createElement("path", {
  d: "m497 335.267h-482c-8.284 0-15-6.716-15-15v-305.267c0-8.284 6.716-15 15-15h482c8.284 0 15 6.716 15 15v305.267c0 8.284-6.716 15-15 15z",
  fill: "#fff5f0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m512 320.267v-305.267c0-8.284-6.716-15-15-15h-241v335.267h241c8.284 0 15-6.716 15-15z",
  fill: "#f3e4d5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m166.362 154.062c5.195-7.575 8.238-16.736 8.238-26.595 0-25.989-21.144-47.133-47.133-47.133h-32.134c-8.284 0-15 6.716-15 15v144.6c0 8.284 6.716 15 15 15h40.167c30.419 0 55.167-24.748 55.167-55.167 0-18.996-9.649-35.779-24.305-45.705zm-56.029-43.729h17.133c9.447 0 17.133 7.686 17.133 17.133s-7.686 17.133-17.133 17.133h-17.133zm25.167 114.6h-25.167v-50.333h25.167c13.877 0 25.167 11.29 25.167 25.167s-11.29 25.166-25.167 25.166z",
  fill: "#ff9500"
}), /*#__PURE__*/React.createElement("path", {
  d: "m272.066 254.933h-40.166c-8.284 0-15-6.716-15-15v-144.6c0-8.284 6.716-15 15-15s15 6.716 15 15v129.6h25.167c8.284 0 15 6.716 15 15s-6.716 15-15.001 15z",
  fill: "#ff9500"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ff4e00"
}, /*#__PURE__*/React.createElement("path", {
  d: "m416.667 254.933c-8.284 0-15-6.716-15-15v-99.6l-21.2 28.267c-2.833 3.777-7.278 6-12 6s-9.167-2.223-12-6l-21.2-28.267v99.6c0 8.284-6.716 15-15 15s-15-6.716-15-15v-144.6c0-6.457 4.132-12.188 10.257-14.23 6.122-2.04 12.869.065 16.743 5.23l36.2 48.267 36.2-48.267c3.875-5.166 10.621-7.269 16.743-5.23 6.125 2.042 10.257 7.774 10.257 14.23v144.6c0 8.284-6.716 15-15 15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m287.066 239.933c0-8.284-6.716-15-15-15h-16.066v30h16.066c8.285 0 15-6.716 15-15z"
})));

var SvgBlackLivesMatter = function SvgBlackLivesMatter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlackLivesMatter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/black-lives-matter.00e548d5.svg";
export { ForwardRef as ReactComponent };